<div class="customHeader">
    <input
        type="checkbox"
        (click)="onCheckboxChanged($event)"
        [checked]="selectionListingsMap?.size"
        [indeterminate]="selectionListingsMap?.size && selectionListingsMap?.size !== totalNumberOfRows"
    />
    @if (menuVisible()) {
        <ul class="menuList" (clickOutside)="menuVisible.set(false)">
            @if (selectionListingsMap?.size) {
                <li class="menuItem" (click)="deselectAll(); clearSelectionStore()">
                    {{ 'listings.bulk.deselectAll' | translate: { numberOfListings: selectionListingsMap?.size } }}
                </li>
            }
            @if (!(selectionListingsMap?.size && selectionListingsMap?.size === totalNumberOfRows)) {
                <li class="menuItem" (click)="selectAllOnPage()">{{ 'listings.bulk.selectAllOnPage' | translate }}</li>
                @if (selectionListingsMap?.size !== environment.maxBulkEditableListings) {
                    <li class="menuItem" (click)="selectAllAcrossPages()">{{ 'listings.bulk.selectFirstThousand' | translate }}</li>
                }
            }
        </ul>
    }
    @if (selectionListingsMap?.size) {
        <span class="text-xs listingNumber">{{ selectionListingsMap?.size }}</span>
    }
</div>
